import { PulsingLogo } from './PulsingLogo'

/* SendReassuranceAnimationWidget: identical pulsing logo. The Tracking page
 * mounts it centred over the map (Align(0,0) in the Stack) while
 * FFAppState().sendReassuranceAnimation is true. Overlay positioning lives
 * at the call site, exactly as in Flutter. */

export function SendReassuranceAnimation() {
  return <PulsingLogo />
}
